module.exports = __webpack_public_path__ + "img/inspiration_02.aacf82b.webp";